<template>
  <q-btn
    unelevated
    color="primary"
    v-bind="$attrs"
    :class="{ 'animate-icon': animateIcon }"
    :size
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>

    <c-tooltip v-if="tooltip.length">{{ tooltip }}</c-tooltip>
  </q-btn>
</template>

<script setup>
defineProps({
  animateIcon: {
    type: Boolean,
    default: false,
  },
  // Only use SM for size. Where is the default is MD.
  size: {
    type: String,
    default: "md",
    validator: (value) => {
      return ["sm", "md"].includes(value);
    },
  },
  tooltip: {
    type: String,
    default: "",
  },
});
</script>

<style lang="scss">
body.desktop {
  .q-btn.q-focusable {
    .q-focus-helper {
      @apply tw-opacity-0;
    }
  }
}

button.q-btn,
a.q-btn {
  @apply tw-max-w-full;
  text-transform: none !important;

  .q-btn__content {
    @apply tw-flex-nowrap;

    > span {
      @apply tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap;
    }
  }

  &.animate-icon .q-btn__content {
    > .q-icon {
      @apply tw-transition tw-duration-300;
    }
  }

  &.disabled {
    pointer-events: auto !important;
  }

  &.bg-primary {
    --fa-primary-color: white;
    --fa-secondary-color: white;
    --fa-primary-rgba-color: rgba(255, 255, 255, 1);
    --fa-secondary-rgba-color: rgba(255, 255, 255, 0.4);
  }

  .q-icon {
    @apply tw-text-inherit;
  }

  &--outline {
    &:before {
      border: 1px solid $grey;
    }
  }

  .q-icon:not(.material-icons) {
    @apply tw-text-md;
  }
}
</style>
